import { Icon, type IconProps } from '@shared/ui';

/* 只有本 app 用得到的圖示。通用的介面圖示在 `@shared/ui`。 */

/** 刀叉：沒有任何紀錄時的空狀態。 */
export function UtensilsIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M4 3v8a3 3 0 0 0 6 0V3M7 11v10" />
      <path d="M17 3c-1.7 1.2-2.5 3.2-2.5 5.5S15.3 13 17 14v7" />
    </Icon>
  );
}
